<template lang="pug">
.preview-page.setting-inner
  .summary-top
    .summary-top__info.info-summary
      .info-summary__ava К
      .info-summary__info
        .info-summary__title Меладзе в Рыбинске
        .info-summary__text Рыбинск, Дворец спорта "Полет", 16 октября, 19:00
  .preview-page__top
    h2.h2.setting-inner__h2 Добавление и редактирование промокода
    a(href='#' @click.prevent="onSidebar" v-show="this.windowWidth < 1200").sidebar-gamb
      svgicon(name='gamb')

  form.form.new-activity-info
        .new-activity-info__left
          h3.h3 Режим
          .form__group.form__group--flex-col
            p-radio(name="mode"
                    v-model="radio"
                    value="Текстовый промокод"
                    class="input-round p-svg p-round p-pulse"
                    color="primary"
                    required)
              svgicon(name="check" class="svg")
              |Текстовый промокод
            p-radio(name="mode"
                    v-model="radio"
                    value="Несколько случайных"
                    class="input-round p-svg p-round p-pulse"
                    color="primary"
                    required)
              svgicon(name="check" class="svg")
              |Несколько случайных
            p-radio(name="mode"
              v-model="radio"
              value="Промокоды к email"
              class="input-round p-svg p-round p-pulse"
              color="primary"
              required)
              svgicon(name="check" class="svg")
              |Промокоды к email

          h3.h3 Промокод
          .form__group.form__group--big
            label.form__label Введите промокод (или несколько через запятую. Например: test, тест)*
            .form__full
                input(type='text' required v-model="nameActivity").form__input
                a(href='#').btn Сгенерировать

          h3.h3 Тип скидки
          .form__group.form__group--flex-col
                p-radio(name="visible-activity"
                    v-model="radio2"
                    value="% "
                    class="input-round p-svg p-round p-pulse"
                    color="primary"
                    required)
                    svgicon(name="check" class="svg")
                    |%
                p-radio(name="visible-activity"
                    v-model="radio2"
                    value="Сумма"
                    class="input-round p-svg p-round p-pulse"
                    color="primary"
                    required)
                    svgicon(name="check" class="svg")
                    |Сумма


          h3.h3 Размер скидки
          .form__group.form__group--big
              label.form__label Введите % (или сумму) скидки*
              .form__full
                  input(type='text' required).form__input

          h3.h3 Количество вводов
          .form__group.form__group--big
                label.form__label Введите количество заказов на которое промокод будет действовать
                    br
                    |(оставьте поле пустым, если не хотите ограничивать)
                .form__full
                    input(type='text' required v-model="nameActivity").form__input

          h3.h3 Мероприятия
          .form__group.form__group--big
              label.form__label Выбрать мероприятия
              .form__full
                  v-select(
                      :options="['рисование столов_правки(г. On-Line) 28.08.2021 15:47:00', 'мероприятие 2', 'мероприятие 3']"
                      :clearable="false"
                      :placeholder="'Выберите мероприятие'"
                  ).form__select
                      template(v-slot:no-options) Извините, нет подходящих вариантов.

          h3.h3 Допустимые сектора
          .form__group.form__group--big
                label.form__label Допустимые сектора
                .form__full
                    v-select(
                        :options="['Стол', 'сектор 2', 'сектор 3']"
                        :clearable="false"
                        :placeholder="'Выберите сектор'"
                    ).form__select
                        template(v-slot:no-options) Извините, нет подходящих вариантов.
          h3.h3 Срок действия скидки С - ДО
          .form__flex.form__flex--date
              .form__group
                  label.form__label Начало*
                  date-picker(v-model="dateStart" format="DD.MM.YYYY" :disabled-date="beforeDateEnd").form__input
                  v-select(
                      :options="hours"
                      :clearable="false"
                      :searchable="false"
                      :placeholder="'00'"
                  ).form__select.form__select--mini
                  span.points :
                  v-select(
                      :options="minutes"
                      :clearable="false"
                      :searchable="false"
                      :placeholder="'00'"
                  ).form__select.form__select--mini
                  span.defis —
              .form__group
                  label.form__label Окончание*
                  date-picker(v-model="dateEnd" format="DD.MM.YYYY" :disabled-date="afterDateStart").form__input
                  v-select(
                      :options="hours"
                      :clearable="false"
                      :searchable="false"
                      :placeholder="'00'"
                  ).form__select.form__select--mini
                  span.points :
                  v-select(
                      :options="minutes"
                      :clearable="false"
                      :searchable="false"
                      :placeholder="'00'"
                  ).form__select.form__select--mini

          h3.h3 Количество билетов в заказе (min/max)
          .form__group.form__group--big
              label.form__label Минимальное (и(или) максимальное) кол-во билетов в заказе, к которым будет применена скидка
              .form__full
                  .form__min-max.min-max
                      a(href='#'
                        v-for='n in 26'
                        ref="minMax"
                        @click.prevent='minMax(n)').min-max__item {{ n - 1 }}

          button.btn.btn--big Сохранить
</template>

<script>
import { mapGetters } from 'vuex';
import { mapMutations } from 'vuex';
export default {
  name: 'PromoNew',
  data() {
    return {
      radio: null,
      radio2: null,
      windowWidth: null,
      dateStart: null,
      dateEnd: null,
      nameActivity: null,
      costTicket: 'cash',
      ageQualCurrent: '0+',
      online: false,
      organizer: null,
      organizerVisible: false,
      showModal: false,
      status: [
        'Планируется (черновик)',
        'Скрыто',
        'Активно'
      ],
      ageQual: [
        {
          value: '0+'
        },
        {
          value: '6+'
        },
        {
          value: '12+'
        },
        {
          value: '14+'
        },
        {
          value: '16+'
        },
        {
          value: '18+'
        },
      ],
    }
  },
  mounted: function () {
    this.$nextTick(function () {
      window.addEventListener('resize', this.resize);
      this.resize()
    })
  },
  methods: {
    ...mapMutations([
      'onSidebar',
    ]),
    minMax: function(index) {
      const n = index - 1
      const current = this.$refs.minMax[n].classList;
      const prev = this.$refs.minMax.findIndex(el => el.classList.contains('prev'));
      this.$refs.minMax.forEach(el => {
        el.classList.remove('one', 'active', 'first', 'last', 'prev')
      })
      if (prev === n || prev < 0) {
        current.add('active', 'one', 'prev')
      } else {
        const start = (prev > n) ? n  : prev
        const end = (prev > n) ? prev + 1 : n
        for (let i = start; i < end; i++) {
          this.$refs.minMax[i].classList.add('active')
        }
        if (prev > n) {
          this.$refs.minMax[start].classList.add('first', 'prev')
          this.$refs.minMax[end - 1].classList.add('last')
        } else {
          this.$refs.minMax[start].classList.add('first')
          this.$refs.minMax[end].classList.add('last', 'prev')
        }
        current.add('active')
      }
    },
    beforeDateEnd(date) {
      if (this.dateEnd != null)
        return date > this.dateEnd;
    },
    afterDateStart(date) {
      if (this.dateStart != null)
        return date < this.dateStart;
    },
    resize() {
      this.windowWidth = document.documentElement.clientWidth;
    },
    addOrganizer() {
        if(this.organizer) {
          this.organizerVisible = true
          this.showModal = false
        }
    }
  },
  computed: {
    ...mapGetters([
      'hours',
      'minutes',
      'cities',
      'activityPlace',
    ]),
  }
}
</script>

<style lang="scss">
.setting-inner{
  .h3{
    margin-top: 0;
  }
  &__h2{
    margin-top: 0;
    margin-bottom: 15px;
  }
  &__flex{
    display: flex;
    margin-bottom: 20px;
    .form__flex{
      margin-bottom: 20px;
    }
  }
  &__col{
    width: 510px;
    max-width: 100%;
    &:first-child{
      margin-right: 40px;
    }
  }
}
.preview-page__top{
  display: flex;
  align-items: center;
  margin-bottom: 25px;
  .h2{
    margin-bottom: 5px;
  }
  .sidebar-gamb{
    margin-left: auto;
  }
}

.form{
    &__flex{
        &--vcenter{
            align-items: center;
        }
        &--date{
            .form__input{
                width: 132px;
                margin-right: 5px;
                padding: 0;
                border: none;
            }
        }
    }
    &__tickets{
        .form__group{
            margin-right: 30px;
        }
    }
    &__group{
        &--age{
            position: relative;
            width: 50px;
            height: 50px;
            border-radius: 50%;
            margin-right: 20px;
            margin-bottom: 0;
            background: #e7f1f8;
            text-align: center;
            line-height: 50px;
            color: #161616;
            font-size: 18px;
            font-weight: 600;
            cursor: pointer;
            input{
                position: absolute;
                top: 0;
                left: 0;
                opacity: 0;
            }
            &:nth-last-child(2){
                margin-right: 0;
            }
            &.checked{
                background-color: #008cff;
                color: #fff;
                cursor: default;
            }
            &:hover{
                background-color: #008cff;
                color: #fff;
            }
        }
        &--online{
            cursor: pointer;
            color: #161616;
            font-size: 14px;
            line-height: 20px;
            margin-bottom: 20px;
            display: inline-block;
            input{
                margin-right: 10px;
            }
            & + h3{
                margin-top: 0;
            }
        }
        &--flex-col{
            display: flex;
            flex-direction: column;
            .input-round{
                margin-bottom: 15px;
            }
        }
    }
    &__input + .btn{
        margin-left: 10px;
    }
    &__full{
        .form__select{
            max-width: 100%;
        }
    }
}
.points{
    display: inline-block;
    vertical-align: top;
    color: #161616;
    font-size: 16px;
    font-weight: 600;
    line-height: 37px;
}
.defis{
    margin: 0 7px;
    color: #161616;
    font-size: 16px;
    font-weight: 600;
    line-height: 25px;
}
.noarea{
    display: flex;
    align-items: center;
    &__text{
        color: #161616;
        font-size: 14px;
        line-height: 20px;
        margin-right: 20px;
    }
}
.image-form{
    background-color: #e7f1f8;
    padding: 20px 30px;
    display: flex;
    margin-bottom: 30px;
    max-width: 440px;
    &__ava{
        width: 110px;
        height: 110px;
        margin-right: 20px;
        border-radius: 50%;
        overflow: hidden;
        img{
            display: block;
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }
    &__info{
        align-self: center;
    }
    &__title{
        color: #161616;
        font-size: 16px;
        font-weight: 600;
        margin-bottom: 15px;
        display: flex;
        align-items: flex-end;
    }
}
.organizer-questions{
    background-color: #e7f1f8;
    padding: 10px 20px;
    display: inline-block;
    margin-bottom: 30px;
    &__title{
        color: #161616;
        font-family: "Open Sans";
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        margin-bottom: 15px;
    }
    &__bottom{
        display: flex;
        font-size: 16px;
        font-weight: 600;
        line-height: 25px;
    }
    &__tel{
        color: #161616;
        text-decoration: none;
        margin-right: 10px;
        &:hover{
            text-decoration: underline;
        }
    }
    &__email{
        color: #008cff;
        text-decoration: none;
        &:hover{
            text-decoration: underline;
        }
    }
}

.min-max{
    border-radius: 17px;
    background-color: #e7f1f8;
    display: flex;
    &__item{
        color: #161616;
        font-size: 16px;
        font-weight: 400;
        font-style: normal;
        letter-spacing: normal;
        line-height: 25px;
        text-decoration: none;
        padding: 5px;
        display: block;
        min-width: 25px;
        text-align: center;
        &:hover{
            border-radius: 18px;
            background-color: #008cff;
            color: #fff;
        }
        &.active{
            background-color: #008cff;
            color: #fff;
            &:hover{
                border-radius: 0px;
                background: #000;
            }
        }
        &.first{
            border-radius: 18px 0 0 18px;
            &:hover {
                border-radius: 18px 0 0 18px;
            }
        }
        &.last{
            border-radius: 0 18px 18px 0;
            &:hover {
                border-radius: 0 18px 18px 0;
            }
        }
        &.one{
            border-radius: 18px;
            &:hover {
                border-radius: 18px;
            }
        }
    }
}
@media (max-width: 1339px) {
    .new-activity-info__left {
        flex-shrink: 0;
    }
}
@media (max-width: 991px) {
    .new-activity-info{
        padding: 0 20px;
    }
    .new-activity-info__content{
        flex-direction: column;
    }
    .new-activity-info__left{
        width: 100%;
        margin-right: 0;
        margin-bottom: 30px;
    }
    .min-max__item{
        min-width: 10px;
    }
}
@media (max-width: 767px) {
    .new-activity-steps__content{
        flex-direction: column;
    }
    .new-activity-steps__steps{
        margin-bottom: 20px;
        margin-right: 0;
    }
    .new-activity-steps__text{
        font-size: 14px;
        line-height: 20px;
    }
    .new-activity-info{
        padding: 0 20px;
    }
    .new-activity-steps{
        padding: 20px;
    }
    .form__group--age{
        margin-top: 10px;
        margin-bottom: 10px;
    }
    .defis{
        display: none;
    }
    .form__flex--date{
        flex-direction: column;
        .form__group{
            width: 100%;
        }
        .form__input{
            width: calc(100% - 185px);
        }
    }
    .setting-inner .new-activity-info{
        padding: 0;
    }
    .form__group--visible .pretty{
        margin-left: 0;
        margin-bottom: 20px;
        &:first-child{
            margin-right: 20px;
        }
    }
    .min-max{
        overflow: auto;
    }
    .min-max__item {
        min-width: 25px;
    }
    .min-max__item:hover {
        border-radius: 18px;
        background-color: transparent;
        color: #161616;
    }
    .min-max__item.active:hover{
        background-color: #008cff;
        color: #fff;
    }
}
@media (max-width: 479px) {
    .form__flex--date .form__input {
        width: calc(100% - 31px);
        margin-right: 0;
        margin-bottom: 15px;
    }
    .form__select--mini {
        width: calc(50% - 30px);
    }
    .image-form{
        padding: 20px;
        flex-direction: column;
    }
    .image-form__ava{
        margin-right: 0;
        margin-bottom: 20px;
    }
    .image-form__info{
        align-self: flex-start;
    }
    .organizer-questions__bottom{
        font-size: 15px;
    }
}
</style>